let moUrlToPreload, moMouseoverTimer, moLastTouchTimestamp;
const moPrefetcher = document.createElement("link"),
  moisSupported = moPrefetcher.relList && moPrefetcher.relList.supports && moPrefetcher.relList.supports("prefetch"),
  moisDataSaverEnabled = navigator.connection && navigator.connection.saveData;
if (moisSupported && !moisDataSaverEnabled) {
  (moPrefetcher.rel = "prefetch"), document.head.appendChild(moPrefetcher);
  const e = { capture: !0, passive: !0 };
  document.addEventListener("touchstart", touchstartListener, e),
  document.addEventListener("mouseover", mouseoverListener, e);
}
function touchstartListener(e) {
  moLastTouchTimestamp = performance.now();
  const t = e.target.closest("a");
  isPreloadable(t) &&
    (t.addEventListener("touchcancel", touchendAndTouchcancelListener, { passive: !0 }),
    t.addEventListener("touchend", touchendAndTouchcancelListener, { passive: !0 }),
    (moUrlToPreload = t.href),
    preload(t.href));
}
function touchendAndTouchcancelListener() {
  (moUrlToPreload = void 0), stopPreloading();
}
function mouseoverListener(e) {
  if (performance.now() - moLastTouchTimestamp < 1100) return;
  const t = e.target.closest("a");
  isPreloadable(t) &&
    (t.addEventListener("mouseout", mouseoutListener, { passive: !0 }),
    (moUrlToPreload = t.href),
    (moMouseoverTimer = setTimeout(() => {
      preload(t.href), (moMouseoverTimer = void 0);
    }, 65)));
}
function mouseoutListener(e) {
  (e.relatedTarget && e.target.closest("a") == e.relatedTarget.closest("a")) ||
    (moMouseoverTimer
      ? (clearTimeout(moMouseoverTimer), (moMouseoverTimer = void 0))
      : ((moUrlToPreload = void 0), stopPreloading()));
}
function isPreloadable(e) {
  if (!e || !e.href) return;
  if (moUrlToPreload == e.href) return;
  const t = new URL(e.href);
  return !((!(t.origin == location.origin || "instant" in e.dataset) || !["http:", "https:"].includes(t.protocol) || ("http:" == t.protocol && "https:" == location.protocol) || (t.hash && t.pathname + t.search == location.pathname + location.search) || "noInstant" in e.dataset) || void 0);
}
function preload(e) {
  moPrefetcher.href = e;
}
function stopPreloading() {
  moPrefetcher.removeAttribute("href");
}